import React from 'react';
import { Box, Button} from '@chakra-ui/react';
import { FaPlus} from 'react-icons/fa';

const AddUsers = () => {
  return (
    <Box>
      <Button
        onClick={() => alert('teddst')}
        variant="outline"
        colorScheme="blue"
        justifyContent="flex-start"
        leftIcon={<FaPlus />}
      >
        Add Users
      </Button>
    </Box>
  );
};

export default AddUsers;